<drop-down-picker
    [ngModel]="internalValue"
    (ngModelChange)="onValueChanges($event)"
    [valid]="isValid$ | async"
    [id]="id"
    [options]="countryOptions"
    [presets]="countryPresents"
    [restStringFn]="restStringFn"
    [noResultsPlaceholder]="'countries.noOptions' | i18next"
    [fullPlaceholderEnabled]="fullPlaceholderEnabled"
    [selectAllPreset]="{label: 'countries.selectAll' | i18next}"
    [fullPlaceholder]="'countries.all' | i18next"
    [disabled]="disabled"
></drop-down-picker>
<svg-image
    *ngIf="!countryOptions.length && emptyListWarning"
    class="warning-hint"
    name="warning-triangle"
    [tooltip]="emptyListWarning | i18next"
></svg-image>
